import { containerTransportGrid_filters } from "./filter";
import { containerTransportGrid_columns } from "./columns";

const containerTransportGrid = {
	...containerTransportGrid_filters,
	...containerTransportGrid_columns
};

export { containerTransportGrid };
